import Modal from '~/components/Modal';
import SelectClient from '~/components/clients/SelectClient';
import { useState } from 'react';
import { formatDateTimeLong } from '~/lib/DateTime';
import useBusinessPostApi from '~/lib/useBusinessPostApi';
import * as Toast from '~/lib/Toast';
import { ObjectTypes } from '~/lib/ObjectTypes';

const EventChangeClientModal = ({ isOpen, onClose, event, onSave }) => {
    const [newClient, setNewClient] = useState(null);
    const fromClient = event.client;

    const { save, isSaving } = useBusinessPostApi(
        `/clients/change/${ObjectTypes.BOOKING_EVENT}/${event.id}`,
    );

    function doSave() {
        if (!newClient?.id || newClient?.id === fromClient?.id) {
            Toast.error('Please choose a different client');
        }
        save({ newClient: newClient.id }).then(result => {
            Toast.success(
                `Successfully updated client to ${newClient.name} (${newClient.email})`,
            );
            onSave();
            onClose();
        });
    }

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <h2>Change Client</h2>

            <div className="text-sm mx-2 text-gray-500 mt-1">
                This will change {event.event_type?.name} on{' '}
                {formatDateTimeLong(event?.client_start)} from the client{' '}
                <span className="font-semibold">
                    {fromClient?.name} ({fromClient?.email})
                </span>
                .
            </div>

            <div className="panel-label mt-4">New Client</div>
            <SelectClient onChange={setNewClient} value={newClient} />

            {!!newClient && (
                <div>
                    <div className="flex items-center space-x-6 mt-4">
                        <button
                            type="button"
                            className="btn-save"
                            onClick={doSave}
                        >
                            {isSaving ? 'Saving...' : 'Change Client'}
                        </button>
                        <button
                            type="button"
                            className="btn-gray-pill-lg"
                            onClick={onClose}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            )}
        </Modal>
    );
};

export default EventChangeClientModal;
